/*import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h1>Hi people</h1>
    <p>Welcome to your new Gatsby site.</p>
    <p>Now go build something great.</p>
    <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
      <Image />
    </div>
    <Link to="/page-2/">Go to page 2</Link>
  </Layout>
)

export default IndexPage
*/

import React from "react"
// import Link from "next/link"
import { Link } from "gatsby"
import styled, { keyframes, css } from "styled-components"
import { lighten } from "polished"
import {
  Colors,
  Header,
  Logo,
  Button,
  Spring2,
  APP_WIDTH,
} from "./../lib/misc.js"
import SEO from "./../components/seo"
import Layout from "./../components/layout"
import Image from "./../components/image"
import { PageView } from "./../lib/analytics.js"
import { Spring } from "react-spring/renderprops"
import emoji from "node-emoji"
// import { Toggle } from "react-powerplug"
// import _ from "underscore"
import String from "react-string"
import Script from "react-script-async"

const C_ = [Colors.orange, Colors.green, Colors.purple, Colors.yellow]
export const Colors_ = [...C_, ...C_, ...C_, ...C_]
export default () => (
  <Layout>
    <SEO title="Bonjour" />
    <PageView />
    <Scale>
      <Float1 />
    </Scale>
    <Scale>
      <Float2 />
    </Scale>
    <Scale>
      <Float3 />
    </Scale>
    <Scale>
      <Float4 />
    </Scale>
    <Grid>
      <Header>
        <HeaderLeft>
          <Link to="/">
            <Spring2
              step={0}
              from={{ opacity: 0, y: 40 }}
              to={{ opacity: 1, y: 0 }}
            >
              {({ opacity, y }) => (
                <LogoContainer
                  style={{ opacity, transform: `translatey(${y}px)` }}
                >
                  <LogoIcon style={{ marginRight: 10 }} />
                  <Logo>
                    <String
                      renderChar={(x, i) => (
                        <span
                          key={`${x}.char.${i}`}
                          style={{
                            color: i < 3 ? Colors.purple : Colors.orange,
                          }}
                        >
                          {x}
                        </span>
                      )}
                    >
                      The Atelier
                    </String>
                  </Logo>
                </LogoContainer>
              )}
            </Spring2>
          </Link>
        </HeaderLeft>
        <HeaderRight>
          <HeaderLink>Français</HeaderLink>
        </HeaderRight>
      </Header>
      <div>
        <MainSection>
          <H0
            style={{ display: "flex", flexDirection: "row", marginBottom: 10 }}
          >
            <String
              renderChar={(x, i) => (
                <Spring
                  key={`${x}.char.${i}`}
                  from={{ opacity: 0, y: 40 }}
                  to={{ opacity: 1, y: 0 }}
                  config={{ tension: 36, friction: 4 }}
                  delay={300 + 100 * i}
                >
                  {({ opacity, y }) => (
                    <Letter
                      style={{
                        color: Colors_[i],
                        opacity,
                        transform: `translate3d(0, ${y}px, 0)`,
                        width: x === " " ? 40 : "auto",
                      }}
                    >
                      {x}
                    </Letter>
                  )}
                </Spring>
              )}
            >
              Bonjour !
            </String>
          </H0>
          {/*
        <Toggle>
          {({ on, toggle }) => (
            <Delay on2={on} delay={3000}>
              {props => (
                <React.Fragment>
                  <Button onClick={toggle}>{props.on2 ? 'on' : 'off'}</Button>
                  <pre
                    style={{
                      textAlign: 'left',
                      padding: 20,
                      backgroundColor: 'rgba(0, 0, 0, .03)',
                    }}
                  >
                    {JSON.stringify(props, null, 2)}
                  </pre>
                </React.Fragment>
              )}
            </Delay>
          )}
        </Toggle>
        */}
          <Spring2
            step={4}
            from={{ opacity: 0, y: 40 }}
            to={{ opacity: 1, y: 0 }}
          >
            {({ opacity, y }) => (
              <div style={{ opacity, transform: `translatey(${y}px)` }}>
                <H1>Nous transformons vos rêves en realité</H1>
              </div>
            )}
          </Spring2>
          <Spring2
            step={5}
            from={{ opacity: 0, y: 40 }}
            to={{ opacity: 1, y: 0 }}
          >
            {({ opacity, y }) => (
              <div style={{ opacity, transform: `translatey(${y}px)` }}>
                <H3>
                  Nous sommes un studio de développement d'applications web et
                  mobiles.
                </H3>
                <div style={{ height: 5 }} />
                <H3>
                  Nous vous aidons à concevoir votre projet sur mesure et en un
                  temps record.
                </H3>
              </div>
            )}
          </Spring2>
          <ButtonsRow>
            <ButtonsRowItem>
              <a
                href="mailto:hello@theatelier.studio?subject=Prise%20de%20contact&body=Bonjour,%0D%0A%0D%0AJe souhaite discuter d'un projet. En voici les details :%20"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Spring2
                  step={6}
                  from={{ opacity: 0, y: 40 }}
                  to={{ opacity: 1, y: 0 }}
                >
                  {({ opacity, y }) => (
                    <div style={{ opacity, transform: `translatey(${y}px)` }}>
                      <Button color={Colors.orange}>Je veux discuter</Button>
                    </div>
                  )}
                </Spring2>
              </a>
            </ButtonsRowItem>
          </ButtonsRow>
        </MainSection>
        <Section color="white">
          <SectionTitle>Nos clients et amis</SectionTitle>
          <ClientsGrid>
            {CLIENTS.map(({ name, logo2, link }, i) => (
              <ClientsGridItem
                key={`client.${i}`}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image filename={logo2} alt="Logo" />
              </ClientsGridItem>
            ))}
          </ClientsGrid>
        </Section>
        <Section color="transparent">
          <SectionTitle>Des questions ? Parlons-en.</SectionTitle>
          <Script src="https://assets.calendly.com/assets/external/widget.js">
            {({ loaded }) => <Calendly loaded={loaded} />}
          </Script>
        </Section>
      </div>
      <Footer>
        The Atelier © {new Date().getFullYear()} • Fait en France avec{" "}
        {emoji.get("heart")}
      </Footer>
    </Grid>
  </Layout>
)

/*
<SceneWrapper>
  <Scene>
    <Card>Example</Card>
  </Scene>
</SceneWrapper>

const SceneWrapper = styled.div`
  perspective: 977px;
  transform: translateZ(200px) skewY(-12deg);
  transform-origin: bottom left;
`;

const Scene = styled.div`
  transform-style: preserve-3d;
  transform: rotateX(0.0259694rad) rotateY(-0.578691rad);
`;

const Card = styled.div`
  width: 885px;
  height: 550px;
  background-color: tomato;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  transform: translate3D(-50%, -50%, 2px) scale(0.462);
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  background-color: #32325d;
  color: #fff;
  font: 20px sans-serif;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden;
  font-size: 90px;
`;
*/

const HeaderLeft = styled.div`
  margin: auto;
`
const HeaderRight = styled.div`
  margin-left: auto;
  display: none;
`
const HeaderLink = styled.a`
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
`
const Letter = styled.div``
const DESKTOP_THRESHOLD = 640
const H0 = styled.h1`
  font-size: 120px;
  line-height: 120px;
  @media screen and (max-width: ${DESKTOP_THRESHOLD}px) {
    font-size: 80px;
    line-height: 80px;
  }
`
const H1 = styled.h1`
  font-size: 36px;
  @media screen and (max-width: ${DESKTOP_THRESHOLD}px) {
    font-size: 28px;
    line-height: 38px;
  }
`
const H2 = styled.h2`
  font-size: 28px;
  @media screen and (max-width: ${DESKTOP_THRESHOLD}px) {
    font-size: 22px;
    line-height: 32px;
  }
`
const H3 = styled.h3`
  font-size: 22px;
  @media screen and (max-width: ${DESKTOP_THRESHOLD}px) {
    font-size: 18px;
    line-height: 28px;
  }
`
const Calendly = styled.div.attrs({
  className: "calendly-inline-widget",
  "data-url": "https://calendly.com/gwendall",
})`
  background-color: white;
  width: 100%;
  max-width: 320px;
  height: 580px;
  margin: auto;
  border-radius: 2px;
  overflow: hidden;
`

const CLIENTS = [
  {
    name: "Société Générale",
    logo:
      "https://www.societegenerale.com/sites/default/files/2018/societe-generale-logo.png",
    logo2: "clients/societe-generale.png",
    link: "https://www.societegenerale.com",
  },
  {
    name: "Arte",
    logo: "http://vandals.arte.tv/img/partners/arte-logo.png",
    logo2: "clients/arte.png",
    link: "https://www.arte.tv",
  },
  {
    name: "Renault",
    logo:
      "https://www.cdn.renault.com/content/dam/Renault/master/new-logo/renault_french_logo_desktop.png",
    logo2: "clients/renault.png",
    link: "https://www.renault.fr/",
  },
  {
    name: "The Family",
    logo:
      "https://wydden.com/wp-content/uploads/2014/05/thefamily-1001startups.jpg",
    logo2: "clients/the-family.png",
    link: "https://www.thefamily.co",
  },
  {
    name: "Daphni",
    logo:
      "https://daphni.com/assets/landing/logo-4df793a372bbc888f495decd300e8fd2f5f1dad0247a750fd6a3bf2a7413832a.svg",
    logo2: "clients/daphni.png",
    link: "https://daphni.com",
  },
  {
    name: "Zest",
    logo: "https://zestmeup.com/web/wp-content/uploads/2018/12/Logo.png",
    logo2: "clients/zest.png",
    link: "https://zestmeup.com",
  },
  {
    name: "Tamers",
    logo:
      "https://static.wixstatic.com/media/817353_7eb21fab10ba43248c226c3d1474f5cf~mv2.jpg/v1/fill/w_254,h_256,al_c/817353_7eb21fab10ba43248c226c3d1474f5cf~mv2.jpg",
    logo2: "clients/tamers.png",
    link: "https://www.tamers.fr",
  },
  /*
  {
    name: "Mon Marché",
    logo:
      "https://cdn.welcometothejungle.co/uploads/organization/logo/9633/155489/mon-marche-fr.png",
    link: "https://www.mon-marche.fr"
  },
  */
  {
    name: "Evaneos",
    logo: "https://www.entreprendre.fr/wp-content/uploads/visu_1539622068.jpg",
    logo2: "clients/evaneos.png",
    link: "https://www.evaneos.fr/",
  },
]
const ClientsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 60px;
  grid-row-gap: 60px;
  > img {
    max-width: 100%;
  }
  @media (max-width: 400px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 20px;
  }
`
const ClientsGridItem = styled.a`
  align-self: center;
  transition: transform 150ms ease;
  &:hover {
    transform: translateY(-2px);
  }
`
/*
const String = ({ renderLetter = x => x, children, ...props }) =>
  typeof children === 'string' && children.split('').map((x, i) => renderLetter(x, i));
*/

/*
const SCRIPT_PROPS = [
  'async',
  'charset',
  'crossOrigin',
  'defer',
  'src',
  'text',
  'type',
  'integrity',
  'nomodule',
  'nonce',
];
class Script extends React.Component {
  static defaultProps = {
    async: true,
  };
  state = { success: false, error: false };
  onLoad = () => this.setState({ success: true, error: false });
  onError = () => this.setState({ success: false, error: true });
  componentDidMount() {
    const { src } = this.props;
    if (!src) console.log('Please provide a prop src to <Script />');
    const exists = !!document.querySelector(`script[src="${src}"]`);
    if (exists) return this.setState({ success: true, error: false });
    const script = document.createElement('script');
    Object.keys(this.props).forEach(k => {
      if (SCRIPT_PROPS.includes(k)) script[k] = this.props[k];
    });
    script.addEventListener('load', this.onLoad);
    script.addEventListener('error', this.onError);
    document.body.appendChild(script);
  }
  render() {
    return this.props.children({ ...this.state });
  }
}
*/

/*
class Delay extends React.Component {
  constructor(p) {
    super(p)
    const { delay, ...props } = p
    this.state = { ...props, updating: false, _next: null }
    this.timeout = null
  }
  componentWillUpdate({ children: c, delay: d = 1000, ...propsNew }) {
    const { children, delay, ...props } = this.props
    if (!_.isEqual(propsNew, props)) {
      this.setState(s => ({ ...s, updating: true, _next: propsNew }))
      this.timeout = setTimeout(
        () => this.setState({ updating: false, ...propsNew, _next: null }),
        d
      )
    }
  }
  componentWillUnmount() {
    this.timeout && clearTimeout(this.timeout)
  }
  render() {
    return this.props.children({ ...this.state })
  }
}
*/

const MainSection = styled.div`
  height: 100vh;
  max-width: 100vw;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  h1 {
    color: rgba(0, 0, 0, 0.7);
    font-weight: bold;
    margin-bottom: 10px;
  }
  h3 {
    color: rgba(0, 0, 0, 0.5);
  }
`
const SECTION_PADDING = 50
const SectionAlt = styled.div`
  padding: ${SECTION_PADDING}px 0;
  width: 100%;
  background-color: ${({ color }) => color};
  > div {
    width: 100%;
    max-width: ${APP_WIDTH}px;
    margin: auto;
    padding: 0 15px;
  }
`
const Section = props => (
  <SectionAlt {...props}>
    <div>{props.children}</div>
  </SectionAlt>
)
const SectionTitle = styled(H2)`
  text-align: center;
  margin-bottom: ${SECTION_PADDING}px;
`
const ButtonsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ n = 1 }) => n}, auto);
  grid-column-gap: 25px;
  flex-direction: row;
  align-items: center;
  margin-top: 30px;
  @media (max-width: 600px) {
    grid-template-columns: auto;
    grid-template-rows: auto auto;
    grid-row-gap: 25px;
  }
`
const ButtonsRowItem = styled.div`
  margin: auto;
`
const style = (deg = 0) => css`
  z-index: 0;
  position: absolute;
  animation: ${keyframes`
		0% {
			transform: translatey(0px) rotate(${deg}deg);
		}
		50% {
			transform: translatey(15px) rotate(${deg}deg);
		}
		100% {
			transform: translatey(0px) rotate(${deg}deg);
		}
	`} 3s ease infinite;
`
const Scale = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transform: scale(1.1);
  @media (max-width: 600px) {
    transform: scale(0.9);
  }
`
const Float1 = styled.div`
  ${style(20)};
  animation-duration: 3s;
  width: 150px;
  margin-left: -75px;
  height: 30px;
  margin-top: -15px;
  top: 20%;
  left: 20%;
  background-color: ${lighten(0.2, Colors.blue)};
`
const Float2 = styled.div`
  ${style(-40)};
  animation-duration: 3.5s;
  width: 200px;
  margin-left: -100px;
  height: 80px;
  margin-top: -40px;
  top: 20%;
  left: 75%;
  background-color: ${lighten(0.2, Colors.yellow)};
`
const Float3 = styled.div`
  ${style(-40)};
  animation-duration: 5s;
  width: 200px;
  margin-left: -100px;
  height: 30px;
  top: 75%;
  left: 25%;
  background-color: ${lighten(0.2, Colors.green)};
`
const Float4 = styled.div`
  ${style(20)};
  animation-duration: 2.5s;
  width: 100px;
  margin-left: -50px;
  height: 30px;
  top: calc(75%);
  left: 75%;
  background-color: ${lighten(0.2, Colors.orange)};
`
const Grid = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-row-gap: 0px;
  min-height: 100vh;
`
const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 15px;
  height: 60px;
  font-size: 16px;
`
const SQUARE_SIZE = 20
const Squares = styled.div`
  float: left;
  width: ${({ size = SQUARE_SIZE }) => size}px;
  height: ${({ size = SQUARE_SIZE }) => size}px;
  > div {
    float: left;
    width: 50%;
    height: 50%;
  }
`
const LogoContainer = styled.span`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: transform 100ms ease;
  &:hover {
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0px);
  }
`
const LogoIcon = props => (
  <Squares {...props}>
    <div style={{ backgroundColor: Colors.orange }} />
    <div style={{ backgroundColor: Colors.purple }} />
    <div style={{ backgroundColor: Colors.green }} />
    <div style={{ backgroundColor: Colors.yellow }} />
  </Squares>
)
